import { render, staticRenderFns } from "./order-company.vue?vue&type=template&id=e4e9f1e2"
import script from "./order-company.vue?vue&type=script&lang=js"
export * from "./order-company.vue?vue&type=script&lang=js"
import style0 from "./order-company.vue?vue&type=style&index=0&id=e4e9f1e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports